var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"quiz__title"},[_vm._v("Skincare Consultation")]),_vm._v(" "),_c('div',{staticClass:"quiz"},[_c('answer-summary'),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('quiz-nav')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ee6628e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/app/js/components/quiz.vue
// module id = 55
// module chunks = 0